import React from 'react'
import PartImageColumn from 'components/partImageColumn'

export const getPartImageColumn = (getClass) => {
  return {
    key: 'icon',
    label: '',
    size: 40,
    onGetContent: (params) => {
      const {key, entity, style, className} = params
      return (
        <span key={key} style={style} className={className}>
          <PartImageColumn
            entity={entity}
            getClass={getClass}
          />
        </span>
      )
    },
  }
}
